const generateFileUrl = token => {
    return `${process.env.REACT_APP_API_VHOST}/files/view/${token}`;
};

export const generator = {
    generateFileUrl
};
